import type { FaireProductEntity } from "../../entity_types/product";

export const p_9p3pbwyarb: FaireProductEntity = {
  token: "p_9p3pbwyarb",
  type: "product",
  name: "Superfruit Gummies - Mango (Multi-Serve)",
  brandToken: "b_c2esz2g9h4",
  brandName: "Blue Stripes",
  imageUrl:
    "https://cdn.faire.com/fastly/45fdb05e4ac9ed4d36b523bcc6a6b989ce36f8a93ec792fd15834aa14fba2b59.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/07c1f32e5e1ad1e30d867e7d80554f08674fa58f8e6cc62ddd8812c60c2a52ae.jpeg",
    "https://cdn.faire.com/fastly/7d25b452ae64b14c6e107337f326ba2d9da31e6f236728ce8dfdbc939303ad46.jpeg",
    "https://cdn.faire.com/fastly/07c21b7fdfc416d17e8f4d85e308d5acf461b52431bdceec2d99859dc28de1ab.jpeg",
  ],
  priceDollars: 6.91,
  description:
    "CHEWY, NATURAL SUPERFOOD SNACK - Bursting with tangy, tropical cacao fruit flavor and a satisfyingly chewy texture, our gummies are a great on-the-go snack for kids and the whole family\n\nFUEL WITH FUNCTION - More than just a treat, each bite delivers essential vitamins and minerals to help support your daily wellness in a delicious, snackable form\n\nNATURALLY SWEET, NO ADDED SUGAR - Sweetness comes naturally from the cacao fruit; no added sugar, no syrups, and nothing artificial, just two ingredients: 100% natural mango and cacao superfruit\n\nCACAO SUPERFRUIT POWER - Made only from the antioxidant-rich cacao superfruit, our gummies support upcycling efforts that reduce waste, empower farmers, and nourish your body naturally\n\nTHE CACAO FRUIT REVOLUTION - Blue Stripes exists to unleash the nutritious power of the cacao fruit, bringing nature’s best to your table, bag, car, or gym with delicious, better-for-you snacks",
  tags: [],
  msrpDollars: 13.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:08.058Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
